import { render } from "./ExtraMetadataSection.vue?vue&type=template&id=7dcffe37&scoped=true&ts=true"
import script from "./ExtraMetadataSection.vue?vue&type=script&lang=ts"
export * from "./ExtraMetadataSection.vue?vue&type=script&lang=ts"

import "./ExtraMetadataSection.vue?vue&type=style&index=0&id=7dcffe37&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcffe37"]])

export default __exports__